import { Result } from '../types'

export interface RegistrationState {
  loading: boolean
  registrationResult: Result
  registrationFolio: String
  registrationRequest: UserRegistrationRequest
  menuOptions: Array<MenuOptions>
  identificationOptions: Array<MenuOptionValue>
  specialityOptions: Array<MenuOptionValue>
  subspecialityOptions: Array<MenuOptionValue>
  consultoryOptions: Array<MenuOptionValue>
}

//Menu options
export interface MenuOptions {
  id: number
  type: string
  tooltip: string
  description: string
  defaultValue: string
}

// Menu options value
export interface MenuOptionValue {
  id: number
  param: string
  value: string
}

// Registration request object
export interface UserRegistrationRequest {
  userId: number
  imageProfileUrl: string
  name: string
  firstSurname: string
  secondSurname: string
  genre: number
  treatment: number
  birthDate: string | null
  email: string
  mobileNumber: string
  phoneNumber: string
  extensionPhoneNumber: string
  curp: string
  rfc: string
  oficialNumberType: string
  oficialNumber: string
  generalMedicineCertificate: string
  generalMedicineInstitute: string
  generalMedicineYearOfDegree: number
  specialtyType: string
  specialty: string
  specialtyCertificate: string
  specialtyInstitute: string
  specialtyYearOfDegree: number
  subSpecialtyEnded: boolean
  subSpecialtyType: string
  subSpecialty: string
  subSpecialtyCertificate: string
  subSpecialtyInstitute: string
  subSpecialtyYearOfDegree: number
  belongMedicalSociety: boolean
  medicalSocietyNumber: string
  belongGynecologySociety: boolean
  gynecologySocietyNumber: string
  belongPediatricsSociety: boolean
  pediatricsSocietyNumber: string
  belongNeonatologySociety: boolean
  neonatologySocietyNumber: string
  belongOtherSociety: boolean
  otherSocietyName: string
  otherSocietyNumber: string
  consultoryType: string
  consultory: string
  medicalProtectionInsurance: boolean
  medicalProtectionInsuranceProvider: string
  medicalProtectionInsuranceNumber: string
  advertisingNotice: boolean
  advertisingNoticeNumber: string
}

export enum MenuType {
  IDENTIFICATION = 1,
  SPECIALITY = 2,
  SUBSPECIALITY = 3,
  CONSULTORY = 4
}
